import React, {useState, useEffect} from "react";
import Home from './pages/Home'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import './App.css';
import Login from './pages/Login'
import {AnimatePresence } from "framer-motion"
import {useStore} from './StateManagement'
import ProfileCreation from "./components/ProfileCreation";

function App() {
  const [user, setUser] = useState(undefined);
  const [stateData, dispatch] = useStore();

  useEffect(()=>{
      const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
      if(userData !== null){
        dispatch({
          type: 'LOG_IN',
          details: userData
        })
      }
  }, []);

  return (
    <div className="app">
      <Router>
        <Switch>
          <Route path="/login" exact={true}>
            {stateData.userDetails.uid === '' ? <Login setUser={setUser} /> : (stateData.userDetails.uid && stateData.userDetails?.name === '') ? <Redirect to="/profile-creation" /> : <Redirect to="/"/>}
          </Route>
          <Route path="/profile-creation" exact={true}>
            {stateData.userDetails.uid === "" ? <Redirect to="/login" /> : stateData.userDetails.name ? <Redirect to="/"/> : <ProfileCreation />}
          </Route>
          <Route path="/chats/:id" exact={true}>
            {stateData.userDetails.name ? <Home type="chat" /> : <Redirect to="/login" />}
          </Route>
          <Route path="/chats/group/:id" exact={true}>
            {stateData.userDetails.name ? <Home type="chat" /> : <Redirect to="/login" />}
          </Route>
          <Route path="/" exact={true}>
            {stateData.userDetails.name ? <Home type="welcome" /> : <Redirect to="/login" />}
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
